<template>
<div class="container">
	<div class="content-list" v-if="data.index_videos" v-for="ty in data.index_videos">

        <div class="item-type">
			<div class="type-name decrypt" :decrypt-text="ty.name"></div>
			<div class="title-labels">
                <div class="item" v-for="e in $group.getDatas(group.data['107'], 1).concat($group.getDatas(group.data['106'], 3))">
                    <a rel="nofollow noopener" referrerpolicy="no-referrer" target="_blank" @click="$group.clickSk(e.id, e.product_id)" :href="$group.getGGUrl(e)" class="decrypt" :decrypt-text="e.name"></a>
                </div>
            </div>
			<div class="type-more"><router-link target="_blank" :to="'/type/'+ty.id+'.htm'">&#x66F4;&#x591A;<i class="el-icon-d-arrow-right"></i></router-link></div>
		</div>

        <div class="item-lists">
            <template v-for="(row, index) in ty.videos">
                <div class="item-list">
                    <a rel="nofollow noopener" referrerpolicy="no-referrer" target="_blank" v-for="e in $group.getDatas(group.data['107'].concat(group.data['106']), 1)" @click="$group.clickSk(e.id, e.product_id)" :href="$group.getGGUrl(e)" class="list-text"><span class="decrypt" :decrypt-text="e.name"></span></a>
                    <router-link target="_blank" :to="'/video/'+row.id+'.htm'">
                        <div class="item-image">
                            <img class="lozad" :src="group.css_domain+'/'+group.path+'/images/load320.gif?ad'" :data-src="group.pic_domain+'/pic/'+row.serial_number+'/thumbnail.css'"/>
                            <div class="item-image-zhao"></div>
                        </div>
                        <div class="item-tag">
                            <span class="item-date" v-if="row.second">{{row.second}}</span>
                            <span class="item-read">
                                <i class="el-icon-view"></i>
                                <span>{{row.read_number}}</span>
                            </span>
                        </div>
                        <div class="item-title decrypt" :decrypt-text="row.title"></div>
                    </router-link>
                </div>
                <!-- 广告部分 --->
                <div class="item-list" v-if="index==7" v-for="e in $group.getDatas(group.data['105'], 2)">
                    <a rel="nofollow noopener" referrerpolicy="no-referrer" target="_blank" @click="$group.clickSk(e.id, e.product_id)" :href="$group.getGGUrl(e)">
                        <div class="item-image">
                            <img class="lazy-load" :src="group.css_domain+'/'+group.path+'/images/load320.gif?ad'" :data-src="group.pic_domain+(e.picture_url.replace('.css', '.js'))"/>
                            <div class="item-image-zhao"></div>
                        </div>
                        <div class="item-tag">
                            <span class="item-date"></span>
                            <span class="item-read">
                                <i class="el-icon-view"></i>
                                <span>9999</span>
                            </span>
                        </div>
                        <div class="item-title decrypt" :decrypt-text="e.name"></div>
                    </a>
                </div>
            </template>
        </div>
        <!-- 固定位 -->
        <div class="infor_flow" v-if="group.data" v-for="e in $group.getDatas(group.data['103'], 1)">
            <a rel="nofollow noopener" referrerpolicy="no-referrer" target="_blank" @click="$group.clickSk(e.id, e.product_id)" :href="$group.getGGUrl(e)">
                <img class="lazy-load" :src="group.css_domain+'/'+group.path+'/images/load640.gif?ad'" :data-src="group.pic_domain+(e.picture_url.replace('.css', '.js'))" width="100%">
            </a>
        </div>
    </div>
</div>
</template>
<script>
export default {
    name: 'home',
    data: function () { 
        return {
            group: Group,
            data: {}
        }
    },
    created: function () {
        var Th = this;
        Th.getIndexVodeos();
        Th.$emit('_function', ['tongji', 'lozad', 'lazy-load', 'decrypt', 'show_new_url', 'show_tanchuang0', 'show_tanchuang1']);
        Th.$emit('page', 'index');
    },
    methods:{
        getIndexVodeos: function() {
            var Th = this;
            Th.$emit('_function', ['loading_open','scrollto']); //加载，回到顶部
            Th.$api.get('/index.json?'+Th.group.csstime, {}, function(data){

                Th.data = data;
                Th.$emit('_function', ['loading_close', 'lozad','lazy-load','decrypt']);
                
            }, function(type, message){ Th.$emit('_function', ['loading_close', 'lozad','lazy-load','decrypt']); });
        },
    },
}
</script>